"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.movingAverageImpressionList = void 0;
const ti_1 = require("react-icons/ti");
const ai_1 = require("react-icons/ai");
const React = require("react");
const general_impression_config_1 = require("./config/general-impression.config");
exports.movingAverageImpressionList = [
    {
        id: 0,
        title: 'Boa',
        subtitle: 'Média móvel',
        description: 'Ao analisar a média móvel do ativo para seu perfil de investidor, utilizando padrões de análises avançadas, grande maioria aprovou o ativo.',
        icon: React.createElement(ti_1.TiChartLineOutline, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        importantLevel: 80,
        reportableIdentification: 'BOA_MEDIAS_MOVEIS',
    },
    {
        id: 1,
        title: 'Média móvel',
        subtitle: 'Ruim',
        description: 'Ao analisar a média móvel do ativo para seu perfil de investidor, utilizando padrões de análises avançadas, grande maioria reprovou o ativo.',
        icon: React.createElement(ai_1.AiOutlineFall, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        importantLevel: 80,
        reportableIdentification: 'RUIM_MEDIAS_MOVEIS',
    },
];
//# sourceMappingURL=moving-average-impressions.data.js.map